import React from "react";

const Landing = () => {
  return (
    <>
      <div className="w-full h-screen overflow-x-hidden overflow-y-auto bg-black bg-gradient-to-br from-black via-[#111111] to-[#1c1c1c] flex flex-col justify-start items-center text-center px-6 animate-fade-in">

        {/* Logo */}
        <img
          src={require("../assets/navbar_logo.png")}
          alt="Chaptr Logo"
          className="w-40 h-auto mt-10"
        />

        {/* Tagline */}
        <p className="text-lg sm:text-xl text-gray-400 mt-4 italic">
          Your next chaptr starts here.
        </p>

        {/* Description */}
        <p className="text-gray-300 max-w-xl mt-6 text-md sm:text-lg leading-relaxed">
          <em>
            Chaptr.org is a digital reading platform built to make literary learning more accessible, engaging, and enjoyable for everyone.
          </em>
          <br className="hidden sm:block mt-2" />
          We curate leveled classics and public domain works to empower learners, educators, and curious minds across the globe.
        </p>

        {/* CTA Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a
            href="https://www.buymeacoffee.com/chaptrorg"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-3 rounded shadow-md transition duration-300"
          >
            ❤️ Support us on BuyMeACoffee
          </a>

          <a
            href="mailto:info@chaptr.org"
            className="border border-gray-500 hover:border-white text-gray-300 hover:text-white px-6 py-3 rounded transition duration-300"
          >
            📩 info@chaptr.org
          </a>
        </div>

        {/* Social Media Links */}
        <div className="flex gap-4 mt-6">
          <a
            href="https://instagram.com/chaptrorg"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#7c3aed] hover:underline"
          >
            Instagram
          </a>
          <a
            href="https://twitter.com/chaptrorg"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#7c3aed] hover:underline"
          >
            Twitter
          </a>
          <a
            href="https://facebook.com/chaptrorg"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#7c3aed] hover:underline"
          >
            Facebook
          </a>
        </div>

        {/* Footer Note */}
        <div className="mt-8 mb-6 text-sm text-gray-500">
          <p>Site under construction – launching soon.</p>
          <p className="mt-2">
            © 2025 Chaptr.org. All rights reserved.
            <br />
            Terms & Conditions | Privacy Policy | Cookies | Contact: info@chaptr.org
          </p>
        </div>

      </div>
    </>
  );
};

export default Landing;

